var map = {
	"./apay.svg": "ec68",
	"./apay_white.svg": "937e",
	"./best2pay.png": "109e",
	"./card-pay_black.svg": "4a12",
	"./card.svg": "e2cf",
	"./card_white.svg": "a8a8",
	"./certificate-check.svg": "caf0",
	"./elecsnet_logo.svg": "e580",
	"./error/qubiq.webp": "d5b3",
	"./error/sphere.webp": "9f06",
	"./fns/fail.svg": "b0e8",
	"./fns/success.svg": "7d53",
	"./google-pay_black.svg": "cfee",
	"./gpay.svg": "8a69",
	"./gpay_white.svg": "8a3b",
	"./lang.svg": "89b7",
	"./lang_black.svg": "215c",
	"./lock.svg": "ad78",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./logo_black.svg": "69fa",
	"./maestro.svg": "f29d",
	"./mastercard.svg": "29b8",
	"./minus-white2.svg": "259d",
	"./minus.svg": "785a6",
	"./mir.svg": "4e2a",
	"./mobi-vtb-logo.svg": "6d93",
	"./moneta_logo_dark.svg": "5444",
	"./mult.svg": "539b",
	"./mult2.svg": "3a15",
	"./mult_white.svg": "918c",
	"./non-empty.svg": "b659",
	"./phone.svg": "7a08",
	"./photo_placeholder.svg": "0027",
	"./plus-white2.svg": "cbce",
	"./plus.svg": "2beb",
	"./plus2.svg": "e62a",
	"./sbp.svg": "b6d1",
	"./sbp_white.svg": "7eea",
	"./telegram.svg": "7315",
	"./tickets/arrow-download.svg": "0816",
	"./tickets/main-image.webp": "a23f",
	"./tkb-logo.svg": "9592",
	"./visa.svg": "6180",
	"./volk-pivo.svg": "d826",
	"./whatsapp.svg": "3776"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";